// Where the product card's clamped-name tooltip opens: under the name by default, over it when
// the viewport has no room below but has room above (a card near the bottom of the screen).
// With room on neither side it stays under the name.

export type NameTooltipPlacement = 'below' | 'above';

/** The tooltip's distance from the name (`--space-1`). */
export const NAME_TOOLTIP_GAP_PX = 4;

export function nameTooltipPlacement(
  nameRect: { readonly top: number; readonly bottom: number },
  tooltipHeight: number,
  viewportHeight: number,
): NameTooltipPlacement {
  const needed = tooltipHeight + NAME_TOOLTIP_GAP_PX;
  const fitsBelow = viewportHeight - nameRect.bottom >= needed;
  const fitsAbove = nameRect.top >= needed;
  return !fitsBelow && fitsAbove ? 'above' : 'below';
}
